import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HintTooltip } from '@brg/ui';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import theme from 'shared/components/__ADDONS__/__MENU__/src/theme/theme';
import {
  LaunchedTopSection,
  LaunchedContent,
  LaunchedTitle,
  PlatformsList,
  PlatformName,
  EditButton,
  TitleContainer,
  QuestionIconContainer,
} from './styles';

interface LaunchedStateProps {
  projectId?: string;
  uploadedPlatforms: string[];
  onEdit?: () => void;
  showEditButton?: boolean;
}

export const LaunchedState: FC<LaunchedStateProps> = ({
  projectId,
  uploadedPlatforms,
  onEdit,
  showEditButton = true,
}) => {
  const { t } = useTranslation();

  return (
    <LaunchedTopSection>
      <LaunchedContent>
        <TitleContainer>
          <LaunchedTitle href={`hseverse://${projectId}`}>{t('room_launch.title')}</LaunchedTitle>
          <QuestionIconContainer href="https://hsedesign.ru/teams/virtualspace" target="_blank" rel="noopener noreferrer">
            <HintTooltip
              text="Virtual Space lab"
              positionY="top"
              noArrow
              customStyle={getTooltipStyles(theme)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_2285_10589)">
                  <circle cx="12" cy="12" r="11.5" stroke="white"/>
                  <path d="M10.9899 14.9318V14.8679C10.997 14.1896 11.068 13.6499 11.203 13.2486C11.3379 12.8473 11.5297 12.5224 11.7783 12.2738C12.0269 12.0252 12.3252 11.7962 12.6732 11.5866C12.8827 11.4588 13.0709 11.3079 13.2378 11.1339C13.4047 10.9563 13.5361 10.7521 13.632 10.5213C13.7314 10.2905 13.7811 10.0348 13.7811 9.75426C13.7811 9.40625 13.6994 9.1044 13.5361 8.84872C13.3727 8.59304 13.1543 8.39595 12.8809 8.25746C12.6075 8.11896 12.3038 8.04972 11.97 8.04972C11.6788 8.04972 11.3983 8.11008 11.1284 8.23082C10.8585 8.35156 10.633 8.54155 10.4519 8.80078C10.2708 9.06001 10.1661 9.39915 10.1377 9.81818H8.79532C8.82373 9.21449 8.97998 8.6978 9.26407 8.26811C9.55171 7.83842 9.92991 7.50994 10.3987 7.28267C10.871 7.0554 11.3948 6.94176 11.97 6.94176C12.595 6.94176 13.1384 7.06605 13.6 7.31463C14.0652 7.56321 14.4239 7.90412 14.676 8.33736C14.9317 8.7706 15.0595 9.2642 15.0595 9.81818C15.0595 10.2088 14.9992 10.5621 14.8784 10.8782C14.7612 11.1942 14.5908 11.4766 14.3671 11.7251C14.1469 11.9737 13.8805 12.1939 13.568 12.3857C13.2555 12.581 13.0052 12.7869 12.817 13.0036C12.6288 13.2166 12.4921 13.4705 12.4068 13.7653C12.3216 14.06 12.2754 14.4276 12.2683 14.8679V14.9318H10.9899ZM11.6717 18.0852C11.409 18.0852 11.1835 17.9911 10.9953 17.8029C10.807 17.6147 10.7129 17.3892 10.7129 17.1264C10.7129 16.8636 10.807 16.6381 10.9953 16.4499C11.1835 16.2617 11.409 16.1676 11.6717 16.1676C11.9345 16.1676 12.16 16.2617 12.3482 16.4499C12.5364 16.6381 12.6305 16.8636 12.6305 17.1264C12.6305 17.3004 12.5862 17.4602 12.4974 17.6058C12.4122 17.7514 12.2967 17.8686 12.1511 17.9574C12.0091 18.0426 11.8493 18.0852 11.6717 18.0852Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_2285_10589">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </HintTooltip>
          </QuestionIconContainer>
        </TitleContainer>
        <PlatformsList>
          {uploadedPlatforms.map((platform) => (
            <PlatformName key={platform}>{platform}</PlatformName>
          ))}
        </PlatformsList>
      </LaunchedContent>
      {showEditButton && onEdit && (
        <EditButton onClick={onEdit}>
          <HintTooltip
            text={t('room_launch.edit_button')}
            positionY="bottom"
            noArrow
            customStyle={getTooltipStyles(theme)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.37437 21.6256L3.42021 17.4423L17.7412 3.12132C18.1317 2.7308 18.7649 2.73079 19.1554 3.12132L20.8787 4.84462C21.2692 5.23514 21.2692 5.86831 20.8787 6.25883L6.55771 20.5798L2.37437 21.6256Z" stroke="#909090" strokeWidth="2"/>
              <rect x="15.7071" y="6.41406" width="1" height="4" transform="rotate(-45 15.7071 6.41406)" fill="#909090"/>
            </svg>
          </HintTooltip>
        </EditButton>
      )}
    </LaunchedTopSection>
  );
};
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HintTooltip } from '@brg/ui';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import theme from 'shared/components/__ADDONS__/__MENU__/src/theme/theme';
import {
  LaunchedTopSection,
  LaunchedContent,
  LaunchedTitle,
  PlatformsList,
  PlatformName,
  EditButton,
  TitleContainer,
  QuestionIconContainer,
} from './styles';

interface LaunchedStateProps {
  projectId?: string;
  uploadedPlatforms: string[];
  onEdit?: () => void;
  showEditButton?: boolean;
}

export const LaunchedState: FC<LaunchedStateProps> = ({
  projectId,
  uploadedPlatforms,
  onEdit,
  showEditButton = true,
}) => {
  const { t } = useTranslation();

  return (
    <LaunchedTopSection>
      <LaunchedContent>
        <TitleContainer>
          <LaunchedTitle href={`hseverse://${projectId}`}>{t('room_launch.title')}</LaunchedTitle>
          <QuestionIconContainer href="https://hsedesign.ru/teams/virtualspace" target="_blank" rel="noopener noreferrer">
            <HintTooltip
              text="Virtual Space lab"
              positionY="top"
              noArrow
              customStyle={getTooltipStyles(theme)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_2285_10589)">
                  <circle cx="12" cy="12" r="11.5" stroke="white"/>
                  <path d="M10.9899 14.9318V14.8679C10.997 14.1896 11.068 13.6499 11.203 13.2486C11.3379 12.8473 11.5297 12.5224 11.7783 12.2738C12.0269 12.0252 12.3252 11.7962 12.6732 11.5866C12.8827 11.4588 13.0709 11.3079 13.2378 11.1339C13.4047 10.9563 13.5361 10.7521 13.632 10.5213C13.7314 10.2905 13.7811 10.0348 13.7811 9.75426C13.7811 9.40625 13.6994 9.1044 13.5361 8.84872C13.3727 8.59304 13.1543 8.39595 12.8809 8.25746C12.6075 8.11896 12.3038 8.04972 11.97 8.04972C11.6788 8.04972 11.3983 8.11008 11.1284 8.23082C10.8585 8.35156 10.633 8.54155 10.4519 8.80078C10.2708 9.06001 10.1661 9.39915 10.1377 9.81818H8.79532C8.82373 9.21449 8.97998 8.6978 9.26407 8.26811C9.55171 7.83842 9.92991 7.50994 10.3987 7.28267C10.871 7.0554 11.3948 6.94176 11.97 6.94176C12.595 6.94176 13.1384 7.06605 13.6 7.31463C14.0652 7.56321 14.4239 7.90412 14.676 8.33736C14.9317 8.7706 15.0595 9.2642 15.0595 9.81818C15.0595 10.2088 14.9992 10.5621 14.8784 10.8782C14.7612 11.1942 14.5908 11.4766 14.3671 11.7251C14.1469 11.9737 13.8805 12.1939 13.568 12.3857C13.2555 12.581 13.0052 12.7869 12.817 13.0036C12.6288 13.2166 12.4921 13.4705 12.4068 13.7653C12.3216 14.06 12.2754 14.4276 12.2683 14.8679V14.9318H10.9899ZM11.6717 18.0852C11.409 18.0852 11.1835 17.9911 10.9953 17.8029C10.807 17.6147 10.7129 17.3892 10.7129 17.1264C10.7129 16.8636 10.807 16.6381 10.9953 16.4499C11.1835 16.2617 11.409 16.1676 11.6717 16.1676C11.9345 16.1676 12.16 16.2617 12.3482 16.4499C12.5364 16.6381 12.6305 16.8636 12.6305 17.1264C12.6305 17.3004 12.5862 17.4602 12.4974 17.6058C12.4122 17.7514 12.2967 17.8686 12.1511 17.9574C12.0091 18.0426 11.8493 18.0852 11.6717 18.0852Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_2285_10589">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </HintTooltip>
          </QuestionIconContainer>
        </TitleContainer>
        <PlatformsList>
          {uploadedPlatforms.map((platform) => (
            <PlatformName key={platform}>{platform}</PlatformName>
          ))}
        </PlatformsList>
      </LaunchedContent>
      {showEditButton && onEdit && (
        <EditButton onClick={onEdit}>
          <HintTooltip
            text={t('room_launch.edit_button')}
            positionY="bottom"
            noArrow
            customStyle={getTooltipStyles(theme)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.37437 21.6256L3.42021 17.4423L17.7412 3.12132C18.1317 2.7308 18.7649 2.73079 19.1554 3.12132L20.8787 4.84462C21.2692 5.23514 21.2692 5.86831 20.8787 6.25883L6.55771 20.5798L2.37437 21.6256Z" stroke="#909090" strokeWidth="2"/>
              <rect x="15.7071" y="6.41406" width="1" height="4" transform="rotate(-45 15.7071 6.41406)" fill="#909090"/>
            </svg>
          </HintTooltip>
        </EditButton>
      )}
    </LaunchedTopSection>
  );
};
